import { render, staticRenderFns } from "./MediaOwnerTags.vue?vue&type=template&id=516c6348&"
import script from "./MediaOwnerTags.vue?vue&type=script&lang=js&"
export * from "./MediaOwnerTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports